import React, { useState, useEffect } from 'react';
import View from '../../components/view';
import Element from '../../components/element';
import utils from '../../components/utils';
import { format } from 'date-fns';

function RelatorioPontuacaoFracionada() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {}, requireds: {}, selected: {} });

  const reportCfg = {
    label: utils.lng('pontos_fracionados', 'Pontos Fracionados'),
    name: 'reportCfg',
    add: false,
    print: true,
    type: 'list',
    table: true,
    auto: true,
    list: {
      url: 'report_pontuacaoFracionadaInternacional',
      validate: 'validaPeriodo',
    },
    filters: {
      periodo: {
        type: 'select',
        label: utils.lng('periodo', 'Período'),
        space: 3,
        value: 'periodo_06',
        data: [
          //{ label: utils.lng('selecione', "Selecione"), value: null },
          { label: '01/06/2026 → 10/07/2026', value: 'periodo_01' },
          { label: '11/07/2026 → 10/08/2026', value: 'periodo_02' },
          { label: '01/07/2026 → 11/08/2026', value: 'periodo_03' },
          { label: '12/08/2026 → 10/09/2026', value: 'periodo_04' },
          { label: '01/08/2026 → 10/09/2026', value: 'periodo_05' },
          { label: '01/09/2026 → 30/09/2026', value: 'periodo_06' }
        ],
      },
      id_cliente: {
        type: 'entity',
        entity: 'Cliente',
        label: utils.lng('cliente_distribuidor', 'Cliente'),
        size: 4,
        list: {
          url:
            utils.getUser().administrativo === true || (utils.getUser().tipo + '').indexOf('ADMINISTRATIVO') > -1
              ? 'endpoint_listar_all_clientes'
              : 'endpoint_listar_clientes_minha_rede',
        },
        itemLabel: 'nome',
        itemValue: 'id',
      },
      mostrar_di_sem_pontos: {
        type: 'checkbox',
        label: utils.lng('mostrar_dis_sem_pontos', 'Mostrar DIs sem pontos'),
        size: 3
      },
      /*
      id_tipo_movimento: {
        type: 'select',
        label: utils.lng('tipo_movimento', 'Tipo Movimento'),
        list: { url: 'TipoMovimento' },
        itemLabel: 'descricao',
        itemValue: 'id',
        rendered: utils.getUser().administrativo === true || (utils.getUser().tipo + '').indexOf('ADMINISTRATIVO') > -1,
      },
      */
    },
    columns: {
      arvore_geracao: {
        field: 'arvore_geracao',
        label: utils.lng('arvore_geracoes', 'Árvore de Gerações'),
        filter: false,
        sort: false,
      },
      codigo_mundial: {
        field: 'codigo_mundial',
        label: utils.lng('codigo_mundial', 'Código Mundial'),
        filter: false,
        sort: false,
      },
      nome_cliente: {
        field: 'nome_cliente',
        label: utils.lng('distribuidor', 'Distribuidor'),
        filter: false,
        sort: true,
      },
      descricao_graduacao_titulo: {
        field: 'descricao_graduacao_titulo',
        label: utils.lng('graduacao', 'Graduação'),
        filter: false,
        sort: false,
      },
      pontos_individuais: {
        field: 'pontos_individuais',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontos_individuais', 'Pontos Individuais'),
        filter: false,
        sort: true,
      },
      pontos_rede: {
        field: 'pontos_rede',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontos_equipe', 'Pontos em Equipe'),
        filter: false,
        sort: true,
      },
      pontuacao_geral: {
        field: 'pontuacao_geral',
        format: 'number',
        type: 'number',
        decimalCount: 2,
        label: utils.lng('pontuacao_geral', 'Pontuação Geral'),
        filter: false,
        sort: true,
      },
      nr_filhos_diretos: {
        field: 'nr_filhos_diretos',
        label: utils.lng('nr_filhos_diretos', 'Nº Filhos Diretos'),
        filter: false,
        sort: false,
      },
      status_penn: { field: 'status_penn', label: utils.lng('status_penn', 'Status Penn'), filter: false, sort: false },
      data_ativacao: {
        field: 'data_ativacao',
        label: utils.lng('data_ativacao', 'Data Ativação'),
        filter: false,
        sort: false,
        type: 'date',
      },
      dh_ultima_compra: {
        field: 'dh_ultima_compra',
        label: utils.lng('dh_ultima_compra', 'Data última compra'),
        filter: false,
        sort: false,
        type: 'date',
      },
      dh_atualizacao_saldo: {
        field: 'dh_atualizacao_saldo',
        label: utils.lng('data_atualizacao', 'Data Atualização'),
        filter: false,
        sort: false,
        type: 'datetime',
      },
    },
  };

  let [mobile, setMobile] = useState(false);

  const resize = function () {
    mobile = window.innerWidth <= 989;
    setMobile(mobile);
    window.mobile = mobile;
  };

  useEffect(() => {
    window.addEventListener('resize', resize.bind(this));
    resize();
  }, []);

  return (
    <View className="ui-view-report" name="rel-pontuacao_fracionada_internacional">
      <Element value={reportCfg} crud={crud} data={crud.data} view={view}></Element>
    </View>
  );
}

export default RelatorioPontuacaoFracionada;
